"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyToClipboard = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("./Button");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const styled_components_1 = __importDefault(require("styled-components"));
const CopyToClipboardStyle = styled_components_1.default.div `
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    width: 100%;

    .clipboard_value {
        border-radius: 4px;
        border-style: solid;
        border-color: var(--color-grey-w, #b6bac0);
        border-width: 1px;
        padding: 8px;
        width: 100%;
        color: var(--color-black, #000);
        text-align: left;
        font-size: 14px;
        line-height: 20px;
    `;
const CopyToClipboard = ({ className, value, buttonText, style }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    async function copyToClipboard(value) {
        // Prefer the async clipboard API when available + secure context
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(value);
            return;
        }
        // Fallback: hidden textarea
        const textArea = document.createElement('textarea');
        textArea.value = value;
        // iOS needs these for selection to work reliably
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.top = '-9999px';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        const selection = document.getSelection();
        const previousRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
        textArea.focus();
        textArea.select();
        // iOS: setSelectionRange to ensure selection
        textArea.setSelectionRange(0, value.length);
        try {
            const ok = document.execCommand && document.execCommand('copy');
            if (!ok)
                throw new Error('execCommand failed');
        }
        finally {
            // cleanup and restore selection
            document.body.removeChild(textArea);
            if (previousRange && selection) {
                selection.removeAllRanges();
                selection.addRange(previousRange);
            }
        }
    }
    return (react_1.default.createElement(CopyToClipboardStyle, { className: className, style: style },
        react_1.default.createElement("div", { className: 'clipboard_value', style: { wordBreak: 'break-all', flex: 1 } }, value),
        react_1.default.createElement(Button_1.Button, { className: `btn_white ${isMobile ? 'mobile-xs' : 'xmd'}`, text: buttonText ? buttonText : "conference.copy", styles: {
                buttonWrap: {
                    maxWidth: isMobile ? 60 : 80,
                    maxHeight: isMobile && 38,
                    boxShadow: 'unset',
                },
            }, onClick: async () => {
                try {
                    await copyToClipboard(value);
                }
                catch (e) {
                    console.error(e);
                }
            } })));
};
exports.CopyToClipboard = CopyToClipboard;
